// extracted by mini-css-extract-plugin
export default {"title":"MediumTittle_title__JOQDU","yellow":"MediumTittle_yellow__7qdbZ","white":"MediumTittle_white__V6PzU","bold":"MediumTittle_bold__heitK"};